var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "content-class": "rounded"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('v-toolbar', {
    attrs: {
      "tile": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-size-16 font-size-lg-20 font-weight-bold text-center white--text"
  }, [_vm._v(_vm._s(_vm.title))]), _c('v-spacer'), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "white"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1), _vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }